import styled from 'styled-components';

export const Term = styled('span')`
  white-space: nowrap;
  color: inherit;
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: help;
  display: inline-block;
  background-color: ${({ theme }) => theme.color.brand01RGBA(0.1)};
`;

export const TooltipTitle = styled('p')`
  margin: 0;
  max-width: 200px;
  color: ${({ theme }) => theme.color.spaceGray};
  ${({ theme }) => theme.typography.tiny};
`;
